import * as React from 'react';
import { useEffect } from 'react';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import useAppContext from '../../../../../../hooks/useAppContext/useAppContext';
import { InputUI } from '../../../../../UI/Input/Input';
import { MediaTypes } from '../../../../../../commands/practitioner/enums/MediaTypes';
import { detectMediaTypeFromUrl, isGifUrl } from '../../../../../../utils/mediaDetection';

interface MediaInputProps {
  index: number;
  isAudioChecked: boolean;
  onEnter?: () => void;
}
export default function MediaInput(props: MediaInputProps): JSX.Element {
  const { isAudioChecked, onEnter } = props;
  const { hasDevice } = useAppContext();
  const {
    practitionerMediaURI,
    setPractitionerMediaURI,
    practitionerMediaType,
    savedUri,
    lastTypeWhenURISaved,
    isMediaLoaded,
    setPractitionerMediaType,
  } = usePractitionerControlsContext();
  const valueFoInput =
    lastTypeWhenURISaved === practitionerMediaType && practitionerMediaURI === '' ? savedUri : practitionerMediaURI;

  useEffect(() => {
    autoType(practitionerMediaURI, isAudioChecked);
  }, [isAudioChecked]);

  const inputHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    let URI = event.target.value.trim();

    if (hasDevice && isGifUrl(URI)) {
      setPractitionerMediaURI('');
      return;
    }

    autoType(URI, isAudioChecked);
    setPractitionerMediaURI(URI);
  };

  const autoType = (URI: string, isAudio: boolean) => {
    const mediaType = detectMediaTypeFromUrl(URI);
    const isYoutubeUrl = URI.includes('youtube.com') || URI.includes('youtu.be');

    if (mediaType === MediaTypes.VIDEO && isYoutubeUrl && isAudio) {
      setPractitionerMediaType(MediaTypes.AUDIO);
    } else {
      setPractitionerMediaType(mediaType ?? MediaTypes.VIDEO);
    }
  };

  return (
    <InputUI
      isLoaded={isMediaLoaded}
      onChange={inputHandler}
      checked={isAudioChecked}
      title={'URL'}
      value={valueFoInput}
      label={'media-modal-content-input'}
      dataTestId="pwid-media-url-input"
      onEnter={onEnter}
    />
  );
}
